define(function (){
    'use strict';
    var Util = Util || {};
    Util.Domain = Util.Domain || {
        _urlEnd: '.oss-cn-beijing.aliyuncs.com/',
        _protocolStr: 'http://',
        _imgPre: 'img-bo',
        _docPre: 'doc-bo',
        _videoPre: 'video-bo',
        _env: 'env',
        getImg: function (){
            return this._getValueByType(this._imgPre);
        },
        getDoc: function (){
            return this._getValueByType(this._docPre);
        },
        getVideo: function (){
            return this._getValueByType(this._videoPre);
        },
        _getValueByType: function(type) {
            return this._protocolStr.concat(type).concat(this._getEnv()).concat(this._urlEnd);
        },
        _getEnv: function() {
            var arr,reg=new RegExp("(^| )" + this._env + "=([^;]*)(;|$)");
            if(arr=document.cookie.match(reg))
                return '-'.concat(decodeURIComponent(arr[2]));
            else
                return '';
        }
    };
    return Util;
});


// WEBPACK FOOTER //
// ./static/js/util.js